export enum WeatherTypeEnum {
  cloudy = "cloudy",
  fog = "fog",
  hail = "hail",
  hazy = "hazy",
  hurricane = "hurricane",
  lightning = "lightning",
  lightningRainy = "lightningRainy",
  partlyCloudy = "partlyCloudy",
  partlyLightning = "partlyLightning",
  partlyRainy = "partlyRainy",
  partlySnowy = "partlySnowy",
  partlySnowyRainy = "partlySnowyRainy",
  pouring = "pouring",
  snowy = "snowy",
  snowyHeavy = "snowyHeavy",
  snowyRainy = "snowyRainy",
  tornado = "tornado",
  windy = "windy",
  sunny = "sunny",
  sunnyAlert = "sunnyAlert",
  rainy = "rainy",
  windyVariant = "windyVariant",
  snowflake = "snowflake",
}

export const weatherTypeEnumNameMap: Record<WeatherTypeEnum, string> = {
  [WeatherTypeEnum.cloudy]: "Cloudy",
  [WeatherTypeEnum.fog]: "Fog",
  [WeatherTypeEnum.hail]: "Hail",
  [WeatherTypeEnum.hazy]: "Hazy",
  [WeatherTypeEnum.hurricane]: "Hurricane",
  [WeatherTypeEnum.lightning]: "Lightning",
  [WeatherTypeEnum.lightningRainy]: "Lightning Rainy",
  [WeatherTypeEnum.partlyCloudy]: "Partly Cloudy",
  [WeatherTypeEnum.partlyLightning]: "Partly Lightning",
  [WeatherTypeEnum.partlyRainy]: "Partly Rainy",
  [WeatherTypeEnum.partlySnowy]: "Partly Snowy",
  [WeatherTypeEnum.partlySnowyRainy]: "Partly Snowy Rainy",
  [WeatherTypeEnum.pouring]: "Pouring",
  [WeatherTypeEnum.snowy]: "Snowy",
  [WeatherTypeEnum.snowyHeavy]: "Snowy Heavy",
  [WeatherTypeEnum.snowyRainy]: "Snowy Rainy",
  [WeatherTypeEnum.tornado]: "Tornado",
  [WeatherTypeEnum.windy]: "Windy",
  [WeatherTypeEnum.sunnyAlert]: "Hot",
  [WeatherTypeEnum.rainy]: "Rainy",
  [WeatherTypeEnum.windyVariant]: "Windy",
  [WeatherTypeEnum.snowflake]: "Icy",
  [WeatherTypeEnum.sunny]: "Sunny",
};
